import { render, staticRenderFns } from "./periodicFunctionality.vue?vue&type=template&id=0ccd56ef&scoped=true&"
import script from "./periodicFunctionality.vue?vue&type=script&lang=js&"
export * from "./periodicFunctionality.vue?vue&type=script&lang=js&"
import style0 from "./periodicFunctionality.vue?vue&type=style&index=0&id=0ccd56ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccd56ef",
  null
  
)

export default component.exports